import React from 'react';
import {
  Box,
  Skeleton,
  Stack,
  useMobileBreakpoint
} from '@customink/pigment-react';

export default function MultiItemCardSkeleton() {
  const isMobile = useMobileBreakpoint();
  return (
    <Stack gap={1} direction="row" flexWrap="wrap">
      {/* Product Image */}
      <Skeleton
        aria-busy
        variant="rectangular"
        width={isMobile ? 78 : 94}
        height={isMobile ? 78 : 94}
        sx={{borderRadius: 1}}
      />

      <Stack sx={{flex: 1, gap: 1}}>
        {/* Category/Type */}
        <Skeleton aria-busy width={100} height={24} />

        {/* Product Title */}
        <Skeleton aria-busy width="60%" height={18} />

        {/* Colors Available */}
        <Skeleton aria-busy width={140} height={18} />
      </Stack>

      {/* Add Style Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: isMobile ? '100%' : 'auto',
          justifyContent: isMobile ? 'flex-start' : 'center',
          mt: isMobile ? 1 : 0
        }}>
        <Skeleton
          aria-busy
          variant="rectangular"
          width={100}
          height={20}
          sx={{borderRadius: 1}}
        />
      </Box>
    </Stack>
  );
}
